import { render } from "./LiveDevStats.vue?vue&type=template&id=58c0a0d6&scoped=true"
import script from "./LiveDevStats.vue?vue&type=script&lang=js"
export * from "./LiveDevStats.vue?vue&type=script&lang=js"

import "./LiveDevStats.vue?vue&type=style&index=0&id=58c0a0d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c0a0d6"]])

export default __exports__